import { useMemo } from 'react';

import { useTenantContext } from '~/context/TenantProvider';
import { useUserInfoContext } from '~/context/UserInfoProvider';
import useIsSsku from '~/hooks/tenant/useIsSsku';
import env from '~/util/env';

const companyIdWithContentRestrictions = env.isStaging() || env.isDev() ? '490' : '2019';

export type ContentAvailability = ReturnType<typeof useContentAvailability>;

const useContentAvailability = () => {
  const { userInfo, userLoading } = useUserInfoContext();
  const isSsku = useIsSsku();
  const { config } = useTenantContext();
  const isContentAvailableForCompany = userInfo?.company?.id !== companyIdWithContentRestrictions;

  return useMemo(
    () => ({
      // todo: remove after BE will add filtering on their side
      experts: isContentAvailableForCompany,
      courses: isContentAvailableForCompany,
      pathways: isContentAvailableForCompany,
      // todo: remove after BE will add filtering on their side
      categories: isContentAvailableForCompany,
      // todo: remove after BE will add filtering on their side
      notifications: isContentAvailableForCompany,
      glossary: isSsku ? false : isContentAvailableForCompany,
      insights: config.hasInsights ? isContentAvailableForCompany : config.hasInsights,
      loading: userLoading,
    }),
    [isContentAvailableForCompany, config, isSsku, userLoading],
  );
};

export default useContentAvailability;
